// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1Jshx","author":"Table_author__2M5Ij","authorImage":"Table_authorImage__3Cx8k","unreadRow":"Table_unreadRow___HxbS"};